import React, {Component} from 'react';
import { Router, BrowserRouter, Switch, Route } from 'react-router-dom';

// import configs from './config'
// import pages /*, { Deeplearn, Choose, Main, Elementary, Inclusive, Final }*/ from './pages'
import './App.css';
import Deeplearn from "./pages/Deep-Learning";
import Elementary from "./pages/Elementary";
// import Inclusive from "./pages/Inclusive";
import Final from "./pages/Final";
import Main from "./pages/Main";
import Choose from "./pages/Choose";
import Test from "./pages/Test.js";


class App extends Component {
  state = {
    userInfo: null,
    user: null,
    classNumber: null,
    subject: null,
    teacher: null,
    availableClasses: {
      deep: [],
      final: [],
      elementary: []
    },
    availableSubjects: {
      deep: [],
      final: [],
      elementary: []
    }
  };

  setClass = classNumber => this.setState({classNumber});
  setSubject =   subject => this.setState({subject});
  setTeacher =   teacher => this.setState({teacher});


  render() {

    return (
      <BrowserRouter  basename={'' || '/info/online-teacher/#'} >
        <Switch>
          <Route
            exact path={'/'}
            render={() => <Main {...this.state} />}

          />
          <Route exact
                 path={'/teacher'}
                 render={() => <Choose {...this.state}
                    setClass={this.setClass}
                    setSubject={this.setSubject}
                    setTeacher={this.setTeacher}
                 />}
          />
          <Route exact
                 path={'/deeplearning'}
                 render={() => <Deeplearn {...this.state}
                    setClass={this.setClass}
                    setSubject={this.setSubject}
                    setTeacher={this.setTeacher}
                 />}
          />
          <Route exact
                 path={'/elementary'}
                 render={() => <Elementary {...this.state}
                    setClass={this.setClass}
                    setSubject={this.setSubject}
                    setTeacher={this.setTeacher}

                 />}
          />
          <Route exact
                   path={'/final'}
                   render={() => <Final {...this.state}
                      setClass={this.setClass}
                      setSubject={this.setSubject}
                      setTeacher={this.setTeacher}

                   />}

          />
          <Route exact
                 path={process.env.PUBLIC_URL + '/test'}
                 render={() => <Test/>}

          />
          <Route
            exact path={'*'}
            render={() => <Main {...this.state} />}

          />
          <Route/>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
